module.exports = function(input, num) {
  return input % parseInt(num, 10) == 0
}
